import React from 'react'
import './Button.css'
import { motion } from 'framer-motion'
import ButtonLoader from './Component/ButtonLoader'

export default function Button(props) {
  var isLoading = props.isLoading ?? false;
  return (
    <motion.button
      className={`primary-button 
      ${props.className} 
      ${props.disabled || isLoading ? 'disabled' : ''}
      `}
      style={props.style}
      onClick={props.onClick}
      whileTap={{
        scale: 0.9
      }}
      isLoading={props.isLoading ?? false}

    >
      {
        <>
          <div className='content' style={{
            visibility: isLoading ? 'hidden' : 'visible'
          }}>
            {props.icon}
            {props.name}
          </div>
          {isLoading ?
            <ButtonLoader />
            : ''}
        </>
      }
    </motion.button>
  )
}
